var _circle, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCcpFeatureIcon1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    fill: "#F2E6F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5882 35.965C30.6451 35.965 37.1765 29.9918 37.1765 22.6236C37.1765 15.2554 30.6451 9.28223 22.5882 9.28223C14.5314 9.28223 8 15.2554 8 22.6236C8 29.9918 14.5314 35.965 22.5882 35.965Z",
    fill: "url(#paint0_linear_7134_5592)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5873 33.4629C29.1335 33.4629 34.4403 28.6098 34.4403 22.6231C34.4403 16.6364 29.1335 11.7832 22.5873 11.7832C16.0411 11.7832 10.7344 16.6364 10.7344 22.6231C10.7344 28.6098 16.0411 33.4629 22.5873 33.4629Z",
    fill: "#F5BE00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1489 25.2865C27.1489 21.2032 20.5577 22.0012 20.5577 19.5889C20.5577 18.3298 22.1059 18.2631 22.5901 18.2631C23.7535 18.2631 24.8768 18.5483 25.7329 18.916C26.0028 19.0319 26.3128 18.8601 26.3128 18.5883V17.4001C26.3128 17.0015 26.1487 16.7655 25.887 16.6721C25.2998 16.4637 24.4574 16.3111 23.211 16.2736V14.9661C23.211 14.8094 23.0724 14.6826 22.901 14.6826H22.281C22.1096 14.6826 21.971 14.8094 21.971 14.9661V16.2944C20.0362 16.4662 18.0312 17.4643 18.0312 19.7857C18.0312 24.0182 24.6224 23.1786 24.6224 25.4074C24.6224 26.1078 24.1328 26.7115 22.5901 26.7115C21.0392 26.7115 19.6141 26.2162 18.8254 25.8477C18.5601 25.7234 18.2473 25.9035 18.2473 26.1762V27.5287C18.2473 27.788 18.4178 28.019 18.6795 28.1199C19.6141 28.4826 20.8677 28.7578 21.9701 28.8378V30.2829C21.9701 30.4396 22.1087 30.5664 22.2801 30.5664H22.9001C23.0715 30.5664 23.2101 30.4396 23.2101 30.2829V28.8412C26.1031 28.621 27.1489 26.85 27.1489 25.2865Z",
    fill: "#FEE119"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7134_5592",
    x1: 12.5752,
    y1: 13.4664,
    x2: 31.0726,
    y2: 33.6925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEDE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcpFeatureIcon1);
export default __webpack_public_path__ + "static/media/ccp-feature-icon-1.266b6910da0fce5c04ae48cd81760760.svg";
export { ForwardRef as ReactComponent };